import { TComplianceItem } from '@commenda/types/src/compliance-calendar/compliances/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export function useGetComplianceItem(complianceId: string) {
  const url = complianceId ? `compliance/${complianceId}` : null;

  const {
    data,
    error,
    mutate,
  }: {
    data?: {
      compliance: TComplianceItem;
    };
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    url,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
  };
}
